<template>
  <div class="row g-0">
    <div class="col-6 col-md-6">
      <el-autocomplete
        v-model="query"
        clearable
        class="form-control border-0 border-end p-0"
        :fetch-suggestions="querySearchAsync"
        placeholder="Buscar una clase online..."
        @keyup.enter="search"
      />
    </div>
    <div class="col-4 col-md-3">
      <el-select
        class="btn btn-outline-primary bg-white text-primary border-0 p-0"
        v-model="category_id"
        placeholder="Categorias"
        clearable
      >
        <el-option
          v-for="category in categories"
          :key="category.id"
          :label="category.name"
          :value="category.id">
        </el-option>
      </el-select>
    </div>
    <div class="col-2 col-md-3 ps-1">
      <button
        class="btn btn-primary px-3 px-md-5 border-0 rounded-1 w-100"
        type="button"
        @click="search"
        @keyup.enter="search"
      >
        <i class="icon-search small"></i>
        <span class="d-none d-lg-inline"> Buscar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Search",
  props: {
    s_category_id: {
      type: Number,
      default: null
    },
    s_query: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      query: '',
      category_id: null,
      categories: [],
    }
  },
  created() {
    this.getCategories();
    this.query = this.s_query
  },
  methods: {
    querySearchAsync(queryString, cb) {
      if (queryString || this.category_id) {
        axios.get('/api/search-front', {
          params: {
            query: queryString,
            category_id: this.category_id,
          }
        }).then(result => {
          console.log(result.data);
          cb(result.data);
        }).catch(error => {
          console.log('querySearchAsync');
          console.log(error);
          cb([]);
        })
      } else{
          cb([]);
      }
    },
    getCategories() {
      axios.get('/api/lesson-categories', {
        params: {
          active: true,
        }
      }).then(result => {
        this.categories = result.data.data;
        this.category_id = this.s_category_id;
      }).catch(error => {
        console.log('getCategories');
        console.log(error);
      })
    },
    search(){
      if(this.category_id){
        let category_slug = this.categories[this.categories.findIndex(x => x.id === this.category_id)].slug;
        window.location.href = `/${category_slug}${this.query ? '?search='+this.query : ''}`
      } else{
        window.location.href = `/resultados${this.query ? '?search='+this.query : ''}`
      }
    }
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
  .form-control:read-only{
    background-color:transparent!important;
  }
  .el-autocomplete.border-end {
    border-right: 2px solid #dee2e6 !important;
    border-radius:0!important;
  }
  .el-input__inner {
    border: 0px solid #555659!important;
    border-radius:0!important;
    font-size:1rem!important;
    &::placeholder {
      color: #555659!important;
    }
  }
</style>
